export default __webpack_public_path__ + "static/media/phone_icon_haiti.4792c7de.png";